import {Button, Nav, Tab} from 'react-bootstrap'
import ChatHistory from './ChatHistory'
import {useChatContext} from '../Context'
import ChatWindow from './ChatWindow'
import TopBarProgress from 'react-topbar-progress-indicator'

function ChatContainer() {
  const {startNewChat, messageDataHelpers} = useChatContext()

  return (
    <div style={{marginTop: '-44px', height: '95vh'}} className=" d-flex flex-column">
      <Tab.Container defaultActiveKey="parent">
        <Nav variant="tabs" className="border-0">
          <Nav.Item className="fs-5">
            <Nav.Link eventKey="parent" className="px-5">
              <span className="px-5 text-dark">Parents</span>
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content style={{height: '92%'}}>
          <Tab.Pane eventKey="parent" className="h-100">
            <div className="m-0 d-flex h-100">
              <div
                className="bg-white p-4 w-25 h-100 overflow-auto"
                style={{
                  borderBottomLeftRadius: '8px',
                }}
              >
                <Button className="w-100 mt-2 mb-5 rounded-3 gradient-btn" onClick={startNewChat}>
                  New Message
                </Button>
                <ChatHistory />
              </div>
              <div className="w-75 h-100">
                <ChatWindow />
              </div>
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
      {messageDataHelpers.isRefetchingMessages && <TopBarProgress />}
    </div>
  )
}

export default ChatContainer
